import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Pages/Home/Main.jsx';
import ProjectsPage from './Pages/Projects/Main.jsx';
import ExperiencePage from './Pages/Experience/Main.jsx';
import ResumePage from './Pages/Resume/Main.jsx';
import BlogPage from './Pages/Blog/Main.jsx';
import BlogPost from './Pages/Blog/Post.jsx';
import './index.css';


ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/experience" element={<ExperiencePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/resume" element={<ResumePage />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
